/*:: type Health = Record<string, { health: boolean, lastPostId: string }>;*/

/*:: type ProfileConfig = {
  branding: {
    colors: {
      primary: string
    }
  }
}*/

/*:: type BrandStyle = {
  id: string,
  name: string,
  current: boolean,
  restricted: boolean
}*/

/* eslint no-use-before-define: 0 */
class SocialProfile {
  constructor({
    /*: {
        id: string,
        name: string,
        timezone: string,
        enabled: boolean,
        socialAccounts: Array<string>,
        brandStyles: Array<BrandStyle>,
        isLinked: boolean,
        healthy: 'yes' | 'no',
        health: Health,
        created: string,
        config: ProfileConfig,
        plan: string
      }*/

    id,
    name,
    timezone,
    enabled,
    socialAccounts,
    brandStyles,
    isLinked,
    healthy,
    health,
    created,
    config,
    plan
  }) {
    this.id = id;
    this.enabled = enabled;
    this.name = name;
    this.timezone = timezone;
    this.socialAccounts = socialAccounts;
    this.brandStyles = brandStyles;
    this.isLinked = isLinked;
    this.healthy = healthy;
    this.health = health;
    this.created = created;
    this.config = config;
    this.plan = plan;
  }

} // eslint-disable-next-line arrow-body-style


SocialProfile.parse = (json
/*: Object*/
) =>
/*: SocialProfile*/
{
  return new SocialProfile({
    id: json.id,
    enabled: json.enabled,
    name: json.name,
    timezone: json.timezone,
    socialAccounts: json.socialAccounts,
    brandStyles: json.brandStyles,
    isLinked: json.isLinked,
    healthy: json.healthy,
    health: json.health,
    created: json.created,
    config: json.config,
    plan: json.plan
  });
}; // eslint-disable-next-line arrow-body-style


SocialProfile.serialize = (profile
/*: SocialProfile*/
) =>
/*: Object*/
{
  return {
    name: profile.name,
    timezone: profile.timezone,
    enabled: profile.enabled,
    branding: serializeBranding(profile.branding)
  };
};

const serializeBranding = branding => {
  if (!branding) return branding;
  if (!branding.colors) return branding;

  if (branding.colors.primary !== undefined) {
    return {
      colors: {
        // Allow `null` to be passed for primary
        primary: branding.colors.primary && String(branding.colors.primary).toLowerCase()
      }
    };
  }

  return undefined;
};

module.exports = SocialProfile;